import { render, staticRenderFns } from "./FindPasswordForm.vue?vue&type=template&id=8a4ab544"
import script from "./FindPasswordForm.vue?vue&type=script&lang=js"
export * from "./FindPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports